import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useDeepCompareEffect } from 'react-use';
import { useForm } from '@dotone/react-ui-core/hooks';
import { useFilterSelector, useSearchSelector, useTranslate } from '@hooks';
import { getOffer, searchOffers } from '@actions';
import { Label, FormGroup } from 'reactstrap';
import { InputClipboard, Alert, Spinner } from '@dotone/react-ui-core';
import { OfferSearchInput } from '../forms';
import OfferEmbeddedSignup from './OfferEmbeddedSignup';

const OfferAffiliateSignupLinkForm = () => {
  const { t, locale, tHtml } = useTranslate(
    'widget',
    'pages.affiliateSignupLink.installInstruction.step2'
  );
  const dispatch = useDispatch();

  const { connectForm, watch } = useForm();
  const offerId = watch('offerId');
  const query = { activePublic: true, locale };

  const { data: offer, isLoading } = useFilterSelector(({ offerCurrent }) => offerCurrent, {
    id: offerId,
    locale,
  });
  const { data: offers, status } = useSearchSelector(({ offerSearch }) => offerSearch, query);

  const { signupLink1, signupLink2, signupLinkRaw } = offer;

  useDeepCompareEffect(() => {
    if (!offers.length) {
      dispatch(searchOffers(query));
    }
  }, [dispatch, offers.length, query]);

  useEffect(() => {
    if (offerId && !offer.id) {
      dispatch(getOffer(offerId, { locale }));
    }
  }, [dispatch, offerId, offer.id, locale]);

  if (status !== 'success') {
    return <Spinner />;
  }

  if (!offers.length) {
    return (
      <Alert variant="warning">
        <p className="text-warning m-0">{t('notEligibleOffer')}</p>
      </Alert>
    );
  }

  return (
    <>
      {connectForm(
        <FormGroup className="d-flex" style={{ maxWidth: 500 }}>
          <Label className="text-md d-flex align-items-center text-dark mr-3">
            {t('selectAnOffer')}
          </Label>
          <OfferSearchInput
            name="offerId"
            loadInitial
            searchParams={query}
            className="flex-grow-1"
          />
        </FormGroup>
      )}
      {!isLoading && offer.id && (
        <>
          <div className="my-4 mb-5">
            <p className="text-dark-primary">{tHtml('optionA')}</p>
            <div
              className="d-flex align-items-end justify-content-start my-3"
              style={{ maxWidth: 500 }}
            >
              <OfferEmbeddedSignup embedScript={signupLink1} className="mr-5" />
              <OfferEmbeddedSignup embedScript={signupLink2} />
            </div>
          </div>

          <div className="my-4">
            <p className="text-dark-primary">{tHtml('optionB')}</p>
            <InputClipboard
              value={signupLinkRaw}
              label={t('widget:actions.copyLink')}
              style={{ maxWidth: 500 }}
            />
          </div>
        </>
      )}
    </>
  );
};

export default OfferAffiliateSignupLinkForm;
